import { Paper, Stack, Text, Title } from '@mantine/core'
import { IconShoppingCart } from '@tabler/icons-react'

export default function EmptyComptoirState() {
  return (
    <Paper
      py={80}
      px="md"
      radius="lg"
      style={{
        border: '1px dashed var(--mantine-color-gray-3)',
        textAlign: 'center',
        backgroundColor: 'transparent',
      }}
    >
      <Stack align="center">
        <IconShoppingCart size={48} />
        <Title order={3}>Aucune commande en cours</Title>
        <Text c="dimmed" size="sm">
          Cliquez sur "Nouvelle commande" pour commencer à servir un client en magasin
        </Text>
      </Stack>
    </Paper>
  )
}
